// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"76":"09b63258","365":"1ec04c87","496":"366c6155","505":"2427aba3","526":"0aa510df","877":"4e960fd2","878":"8b1c3191","905":"98950737","913":"7ebe16aa"}[chunkId] + ".chunk.js";
};